// extracted by mini-css-extract-plugin
module.exports = {"list":"EmployeeList_list__rL5t7","card":"EmployeeList_card__vtyfh"};